import { ComponentClassNames } from '../../../../util/classNames';
import { memoizeFunction, mergeStyleSets } from '../../../../util/styling';

type GetClassNames = () => ComponentClassNames<'mainAreaRowContent'>;

export const getClassNames: GetClassNames = memoizeFunction(() =>
  mergeStyleSets({
    mainAreaRowContent: {
      margin: '0 auto',
    },
  })
);
